import {Divider, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../../style/theme';
import {FilePdfTwoTone} from '@ant-design/icons';
const {Text, Paragraph} = Typography;
const Content = Layout;

const CuatroM = () => {
  return (
    <Layout style={{margin: '0 5.2vh 5.2vh 5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3T' style={{color: appColors['ColorX'], marginTop: '3%'}}>Marketing and Advertising Strategy</Paragraph>
        <Text className='BaseText2'>In iMoAge we believe that <b>our customers are the key element to guarantee our business success.</b>. Consequently, we made a go to market strategy and a purchase funnel analysis in order to illustrate the interaction and process of our users with iMoAge. Also we know we know the importance of advertising strategy in order to build our brand awareness and drive sales. Therefore, we began talking about our project through different plataforms such as our schools newspaper and national TV news in which we were able to explain more about aging and the technology that we developed.</Text>
        <Text className='BaseText' style={{marginTop: '3%', textAlign: 'center'}}><i>In the following PDF you can find the entire  information about our marketing and advertising strategy.</i></Text>
        <Content style={{width: '100%', marginTop: '1%', background: 'transparent', textAlign: 'right'}}>
          <a style={{width: 'fit-content', marginLeft: 'auto', marginRight: '50px', marginBottom: '5px'}} target='_blank' rel='noopener noreferrer' href='https://static.igem.wiki/teams/4464/wiki/emprendimiento/marketing-strategy.pdf'><FilePdfTwoTone style={{fontSize: '8vh'}} twoToneColor='#eb2f96'/></a>
          <p style={{textAlign: 'right'}}><i>Download Here</i></p>
        </Content>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default CuatroM;
